import * as React from "react";

export const useIsInputOverflow = (
  ref: React.MutableRefObject<HTMLInputElement | null>,
  callback?: (hasOverflow: boolean) => void
) => {
  const [isOverflow, setIsOverflow] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    if (ref == null) return;
    const { current } = ref as React.MutableRefObject<HTMLInputElement>;

    const trigger = () => {
      const hasOverflow = current.offsetWidth < current.scrollWidth;
      setIsOverflow(hasOverflow);
      if (callback) callback(hasOverflow);
    };

    if (current) {
      trigger();
    }
  }, [callback, ref, ref.current?.scrollWidth]);

  return isOverflow;
};
